export default __webpack_public_path__ + "static/media/federalbank.e3e86e81.png";